// extracted by css-extract-rspack-plugin
export default {"atDomainCharWrapper":"atDomainCharWrapper-Ff_TJ6","atDomainChar":"atDomainChar-yDCLY3"};